import Select from "components/elements/Select";
import IconInput from "components/elements/IconInput";
import { useState } from "react";
import { useEffect } from "react";
import dataProvider from "core/DataProvider";
import Modal from "components/elements/Modal";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";
import { toast } from "react-hot-toast";
import Table from "components/elements/Table";
import utility from "core/Utils";
import Exporter from "components/elements/Exporter";

const headerMap = {
  brandName: "Brand Name",
  brandCode: "Brand Code",
  brandSector: "Brand Sector",
  brandSectorCode: "Brand Sector Code",
  brandCategory: "Brand Category",
  brandCategoryCode: "Brand Category Code",
  advertiser: "Advertiser",
  advertiserCode: "Advertiser Code",
  advertisingGroup: "Advertising Group",
  advertisingGroupCode: "Advertising Group Code",
  descriptor: "Descriptor",
  descriptorCode: "Descriptor Code",
};

const exportHeaders = [
  { key: "brandName", label: "Brand Name" },
  { key: "brandCode", label: "Brand Code" },
  { key: "brandSector", label: "Brand Sector" },
  { key: "brandSectorCode", label: "Brand Sector Code" },
  { key: "brandCategory", label: "Brand Category" },
  { key: "brandCategoryCode", label: "Brand Category Code" },
  { key: "advertiser", label: "Advertiser" },
  { key: "advertiserCode", label: "Advertiser Code" },
  { key: "advertisingGroup", label: "Advertising Group" },
  { key: "advertisingGroupCode", label: "Advertising Group Code" },
  { key: "descriptor", label: "Descriptor" },
  { key: "descriptorCode", label: "Descriptor Code" },
];

const PromoMaster = props => {
  const [data, setData] = useState([]);
  const [exportFormat, setExportFormat] = useState({
    value: "csv",
    label: "CSV",
  });

  const [search, setSearch] = useState("");
  const [doSearch, setDoSearch] = useState(false);

  const [columns] = useState(utility.optionFromObject(headerMap));
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );
  const [showColModal, setShowColModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSearchKeyDown = e => {
    if (e.keyCode === 13) {
      setDoSearch(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let data = await dataProvider.network.get("/masters/brandpromo/p");

      let transformedData = [];
      let lines = data.split("\n");
      for (let i = 0; i < lines.length; i++) {
        let cols = lines[i].split(",");
        transformedData.push(cols);
      }

      setData(transformedData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load brands");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  return (
    <section id="promo-master">
      {showColModal && colModal}
      <div className="grey-box">
        <div className="left">
          <h3>Program Master</h3>
          <h4>Masters &gt; Program Master</h4>
        </div>
        <div className="right">
          {loading && (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          )}
          {/* <div className="stat">
            <span>{count}</span>
            <span>Available Data</span>
          </div> */}
        </div>
      </div>
      <div className="mtop">
        <div className="pbox flex-full">
          <div className="head flex flex-v-center">
            <div className="right">
              <div className="flex flex-v-center">
                <div className="el">
                  <input
                    type="text"
                    readOnly
                    placeholder="Select Columns"
                    onClick={e => {
                      e.preventDefault();
                      setShowColModal(true);
                    }}
                  />
                </div>
                <div className="el">
                  <IconInput
                    placeholder="Search"
                    icon="search"
                    value={search}
                    onChange={e => {
                      setSearch(e.target.value);
                      setDoSearch(false);
                    }}
                    onKeyDown={handleSearchKeyDown}
                  />
                </div>
                <div className="el">
                  <Select
                    value={exportFormat}
                    onChange={val => {
                      setExportFormat(val);
                    }}
                    options={[{ value: "csv", label: "CSV" }]}
                    placeholder="Format"
                  />
                </div>
                <Exporter
                  format={exportFormat.value}
                  data={data}
                  headers={exportHeaders.map(x => x.label)}
                  filename={`PromoMaster_${utility.formatDate(new Date())}.${
                    exportFormat.value
                  }`}
                />
              </div>
            </div>
          </div>
          <div className="results">
            <Table
              headers={selectedColumns.map(x => x.label)}
              data={data}
              dataType="csv"
              search={doSearch ? search : null}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoMaster;
